import { BrowserRouter } from 'react-router-dom';
import { useEffect } from 'react';
import Router from '../../../config/Router';
import Header from '../header/Header';
import Footer from '../Footer';
import BigBubbles from "./BigBubbles";
import SmallBubbles from "./SmallBubbles";
import useBackground from '../../../hooks/useBackground'
import useCommonTemplate from '../../../hooks/useCommonTemplate';

const Background = () => {

  const background = useBackground();

  const commonTemplate = useCommonTemplate();


  // 戻るボタンが押されたら背景をdeactivate
  useEffect(() => {
    window.addEventListener('popstate', () => { background.deactivate() })
    return () => {
      window.removeEventListener('popstate', () => { background.activate() })
    }
  }, [])

  return (
    <>
      <BrowserRouter>
        {commonTemplate.enabled &&
          <div id="background" className={background.isActive ? "active" : ""}>
            <div id="yeild" >
              <Header />
              <Router />
              <Footer />
            </div>
            <BigBubbles />
            <SmallBubbles />
          </div>
        }
        {!commonTemplate.enabled &&
          <Router />
        }
      </BrowserRouter>
    </>
  );
}
export default Background;